import React, { useState } from 'react';

const Accordion = ({ title, isOpen, setIsOpen, children }) => {

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div
      className="accordion"
      style={{
        border: '1px solid #ddd',
        borderRadius: '0.25rem',
        overflow: 'hidden',
      }}
    >
      <button
        className="accordion-button"
        style={{
          backgroundColor: '#f8f9fa',
          border: 'none',
          padding: '1rem',
          textAlign: 'left',
          cursor: 'pointer',
          width: '100%',
          fontWeight: 'bold',
        }}
        onClick={toggleAccordion}
      >
        {title}
      </button>
      <div
        className="accordion-content"
        style={{
          padding: isOpen ? '1rem' : "0px",
          borderTop: '1px solid #ddd',
          maxHeight: isOpen ? '1000px' : '0px',
          transition: 'max-height 0.2s ease-out',
          visibility: isOpen ? 'visible' : 'hidden',
        }}
      >
        {children}
      </div>
    </div>
  );
};

export default Accordion;
